"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tariffGroupCodeToModifierMap = exports.tariffCodeToGroupId = exports.mapTariffGroupIdToCode = exports.tariffGroupIdToCode = void 0;
exports.tariffGroupIdToCode = {
    1: 'economy',
    2: 'business',
};
const hasGroupId = (id) => [1, 2].includes(id);
const mapTariffGroupIdToCode = (tariffGroupId) => {
    return hasGroupId(tariffGroupId)
        ? exports.tariffGroupIdToCode[tariffGroupId]
        : undefined;
};
exports.mapTariffGroupIdToCode = mapTariffGroupIdToCode;
exports.tariffCodeToGroupId = {
    economy: 1,
    business: 2,
};
exports.tariffGroupCodeToModifierMap = {
    economy: 'green',
    business: 'blue',
};
//# sourceMappingURL=tariffGroupMapper.js.map